// components/Seo.js
import React from 'react';
import { Helmet } from 'react-helmet';
import { shopUrl } from '../lib/seoUtils';

const DEFAULT_OG_IMAGE = shopUrl('/assets/images/home-banner.png');
const DEFAULT_OG_ALT = 'My Private Chemist';

function stripEmptyValues(value) {
  if (value === undefined || value === null || value === '') {
    return undefined;
  }
  if (Array.isArray(value)) {
    const cleaned = value
      .map(stripEmptyValues)
      .filter((item) => item !== undefined);
    return cleaned.length ? cleaned : undefined;
  }
  if (typeof value === 'object') {
    const cleaned = Object.entries(value).reduce((acc, [key, val]) => {
      const next = stripEmptyValues(val);
      if (next !== undefined) {
        acc[key] = next;
      }
      return acc;
    }, {});
    return Object.keys(cleaned).length ? cleaned : undefined;
  }
  return value;
}

const Seo = ({
  title,
  description,
  url,
  image,
  canonical,
  twitterCard = 'summary_large_image',
  structuredData = null,
  noindex = false,
}) => {
  const robotsContent = noindex ? 'noindex, nofollow' : 'index, follow';
  const ogImage = image || DEFAULT_OG_IMAGE;
  const ogUrl = url || canonical;

  return (
    <Helmet>
      <meta name="robots" content={robotsContent} />
      <meta name="googlebot" content={robotsContent} />
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}

      {canonical && <link rel="canonical" href={canonical} />}

      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {ogUrl && <meta property="og:url" content={ogUrl} />}
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:alt" content={title || DEFAULT_OG_ALT} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="en_GB" />
      <meta property="og:site_name" content="My Private Chemist" />

      <meta name="twitter:card" content={twitterCard} />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImage} />

      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(stripEmptyValues(structuredData))}
        </script>
      )}
    </Helmet>
  );
};

export default Seo;
